import { useEffect, useState } from "react";
import styles from "./list.module.css";
import { TextField, Button, Table, TableCell, TableHead, TableContainer, Paper, TableBody, TableRow, TableFooter, Tooltip } from "@mui/material";
import { StyledMainTableCell, StyledMainTableRow } from "../../components/TableComponent";
import TablePaginationComponent from "../../components/TablePagination";
import { Close } from "@mui/icons-material";
import axios from "axios";
import dayjs from "dayjs";
import Loader from "../../components/Loader";
import { TableLoader } from "../../components/ContentLoader";
import { authData, withAdminAuth } from "../../components/GetAuth";
import { Link } from "react-router-dom";
import download from "downloadjs";
import { useReactToPrint } from "react-to-print";
import { ComponentToPrintList } from "./ComponentToPrintList";
import { File, FileText, Home, Search } from "react-feather";
import { useRef } from "react";
import { useCallback } from "react";

const ButtonArea = ({ data }) => {
  const componentRef = useRef();

  const Export = ({ onExport }) => (<Button onClick={(e) => onExport(e.target.value)} className="TableAddBU" style={{ width: "auto" }}>Export To CSV</Button>);

  const convertArrayOfObjectsToCSV = (array) => {
    let result = "";

    const columnDelimiter = ",";
    const lineDelimiter = "\n";
    const keys = ["reference_id", "container_name", "freight", "shipping_from", "shipping_to", "shipping_date", "arrival_date", "consignee", "no_of_invoice", "warehouse_location"];

    keys.forEach((key) => {
      if (key === "reference_id") {
        result += "Shipping Ref";
      } else if (key === "container_name") {
        result += "Container No";
      } else if (key === "freight") {
        result += "Freight Name";
      } else if (key === "shipping_from") {
        result += "Shipping From";
      } else if (key === "shipping_to") {
        result += "Shipping To";
      } else if (key === "shipping_date") {
        result += "Shipping Date";
      } else if (key === "arrival_date") {
        result += "Arrival Date";
      } else if (key === "consignee") {
        result += "Consignee";
      } else if (key === "no_of_invoice") {
        result += "Invoice Count";
      } else if (key === "warehouse_location") {
        result += "Warehouse";
      } else {
        result += key;
      }
      result += columnDelimiter;
    });
    result += lineDelimiter;

    array.forEach((item) => {
      let ctr = 0;
      keys.forEach((key) => {
        if (ctr > 0) result += columnDelimiter;
        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  };

  const downloadCSV = useCallback(() => {
    let newArray = data.map((row) => {
      return {
        reference_id: row.reference_id,
        container_name: row.container_name,
        freight: row.freight,
        shipping_from: row.shipping_from,
        shipping_to: row.shipping_to,
        shipping_date: row.shipping_date ? dayjs(row.shipping_date).format("DD/MM/YYYY") : "-",
        arrival_date: row.arrival_date ? dayjs(row.arrival_date).format("DD/MM/YYYY") : "-",
        consignee: row.consignee,
        no_of_invoice: row.no_of_invoice,
        warehouse_location: row.warehouse_location,
      };
    });

    const link = document.createElement("a");
    let csv = convertArrayOfObjectsToCSV(newArray);
    if (csv == null) return;

    const filename = "shipping-list.csv";

    if (!csv.match(/^data:text\/csv/i)) {
      csv = `data:text/csv;charset=utf-8,${csv}`;
    }
    link.setAttribute("href", encodeURI(csv));
    link.setAttribute("download", filename);
    link.click();
  }, [data]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (<>
    <Export onExport={() => downloadCSV()} />
    <Button onClick={handlePrint} className="TableAddBU" style={{ width: "auto" }}>Print Shippings</Button>
    <div style={{ display: "none" }}>
      <ComponentToPrintList ref={componentRef} data={data} />
    </div>
  </>);
};

const ShippingList = () => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterVars, setFilterVars] = useState({ searchKey: "" });

  const paginationChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const paginationChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const fetchData = () => {
      setContentLoading(true);
      axios.get(process.env.REACT_APP_API_URL + "v1/shippings", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch((error) => {
        setContentLoading(false);
      });
    };

    fetchData();
  }, [API_TOKEN]);

  useEffect(() => {
    let filterredTempData = allData;

    if (filterVars?.searchKey !== "") {
      let inputVal = filterVars?.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredTempData = filterredTempData.filter((item) => {
        return (item?.reference_id.toLowerCase().includes(inputVal) || item?.container_name.toLowerCase().includes(inputVal) || item?.shipping_from.toLowerCase().includes(inputVal) || item?.shipping_to.toLowerCase().includes(inputVal) || item?.consignee.toLowerCase().includes(inputVal) || item?.warehouse_location.toLowerCase().includes(inputVal));
      });
    }

    setFilteredData(filterredTempData);
  }, [allData, filterVars]);

  const convertArrayOfObjectsToCSV2 = (array) => {
    let result = "";

    const columnDelimiter = ",";
    const lineDelimiter = "\n";
    const keys = ["container_id", "booking_id", "item_id", "title", "amount", "recipient_name", "recipient_contact", "recipient_location"];

    keys.forEach((key) => {
      if (key === "container_id") {
        result += "Container Id";
      } else if (key === "booking_id") {
        result += "Booking Id";
      } else if (key === "item_id") {
        result += "Pickup Id";
      } else if (key === "title") {
        result += "Product";
      } else if (key === "amount") {
        result += "Cost";
      } else if (key === "recipient_name") {
        result += "Recipient Name";
      } else if (key === "recipient_contact") {
        result += "Recipient Contact";
      } else if (key === "recipient_location") {
        result += "Recipient Location";
      } else {
        result += key;
      }
      result += columnDelimiter;
    });
    result += lineDelimiter;

    array.forEach((item) => {
      let ctr = 0;
      keys.forEach((key) => {
        if (ctr > 0) result += columnDelimiter;
        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  };

  const downloadItemCSV = (shipId) => {
    axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list/" + shipId).then((response) => {
      if (response.data.status === "SUCCESS") {
        let newArray = response.data.data;
        const link = document.createElement("a");
        let csv = convertArrayOfObjectsToCSV2(newArray);
        if (csv == null) return;
        const filename = "shipping-item-list.csv";

        if (!csv.match(/^data:text\/csv/i)) {
          csv = `data:text/csv;charset=utf-8,${csv}`;
        }
        link.setAttribute("href", encodeURI(csv));
        link.setAttribute("download", filename);
        link.click();
      }
    });
  };

  const downloadItemPdf = (shipId) => {
    axios(process.env.REACT_APP_API_URL + "v1/shippings-item-pdf/" + shipId, {
      responseType: "blob",
    }).then((response) => {
      const content = response.headers["content-type"];
      download(response.data, "itemdownload.pdf", content);
    });
  };

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.MainCard}`}>
        {contentLoading && <TableLoader />}

        {!contentLoading && (<div className={`${styles.PageTitleWrap}`}>
          <p className={`${styles.PageTitle}`}>Shipping List</p>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Shipping</li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>List</li>
            </ol>
          </nav>
        </div>)}

        {!contentLoading && (<>
          <div className="TableFilterHead">
            <div className="DataTableSearch WithFilter">
              <Search className="SearchIcon" />
              <TextField id="search" type="text" placeholder="Search" aria-label="Search Input" value={filterVars?.searchKey} onChange={(e) => setFilterVars((prev) => { return { ...prev, searchKey: e.target.value }; })} />
              {filterVars?.searchKey !== "" && (<Button type="button" className="CloseBU" onClick={(e) => setFilterVars((prev) => { return { ...prev, searchKey: "" }; })}><Close /></Button>)}
            </div>
            <div className="TableFilterBUSec">
              <ButtonArea data={filteredData}></ButtonArea>
            </div>
          </div>
          <div className={`${styles.CoutryTagSec}`}>
            <div className={`${styles.CoutryTag}`}>
              <span className={`${styles.TagColor}`} style={{ background: "#FFFFFF", border: "#000 1px solid" }}></span>
              <span>Container is not shipped</span>
            </div>
            <div className={`${styles.CoutryTag}`}>
              <span className={`${styles.TagColor}`} style={{ background: "rgba(42, 146, 245, 0.4)" }}></span>
              <span>Container shipped from Warehouse</span>
            </div>
            <div className={`${styles.CoutryTag}`}>
              <span className={`${styles.TagColor}`} style={{ background: "rgba(5, 156, 42, 0.5)" }}></span>
              <span>Container received in Ghana</span>
            </div>
            <div className={`${styles.CoutryTag}`}>
              <span className={`${styles.TagColor}`} style={{ background: "rgba(5, 156, 42, 0.9)" }}></span>
              <span>Delivered - Ghana</span>
            </div>
          </div>

          <div className="CusTable">
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <StyledMainTableCell>Shipping Ref#</StyledMainTableCell>
                    <StyledMainTableCell>Container No</StyledMainTableCell>
                    <StyledMainTableCell>Freight Name</StyledMainTableCell>
                    <StyledMainTableCell>Shipping From</StyledMainTableCell>
                    <StyledMainTableCell>Shipping To</StyledMainTableCell>
                    <StyledMainTableCell>Shipping Date</StyledMainTableCell>
                    <StyledMainTableCell>Arrival Date</StyledMainTableCell>
                    <StyledMainTableCell>Consignee</StyledMainTableCell>
                    <StyledMainTableCell>Invoice Count</StyledMainTableCell>
                    <StyledMainTableCell>Warehouse</StyledMainTableCell>
                    <StyledMainTableCell>Action</StyledMainTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => {
                    let backGround;
                    if (item?.status === 1 || item?.status === "1") {
                      backGround = "rgba(42, 146, 245, 0.4)";
                    }
                    if (item?.status === 2 || item?.status === "2") {
                      backGround = "rgba(5, 156, 42, 0.5)";
                    }
                    if (item?.status === 3 || item?.status === "3") {
                      backGround = "rgba(5, 156, 42, 0.9";
                    }
                    return (<StyledMainTableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }} style={{ background: `${backGround}` }}>
                      <TableCell component="th" scope="row">{item?.reference_id}</TableCell>
                      <TableCell component="th" scope="row">{(item?.status === 2 || item?.status === "2" || item?.status === 3 || item?.status === "3") ? (item?.container_name) : !(auth?.user_type === 2 || auth?.permissions?.indexOf('shipping:update') > -1) ? (item?.container_name) : (<Link className={`${styles.ActionLink}`} to={"/shipping/view/" + item?.id}>{item.container_name}</Link>)}</TableCell>
                      <TableCell component="th" scope="row">{item?.freight}</TableCell>
                      <TableCell component="th" scope="row">{item?.shipping_from}</TableCell>
                      <TableCell component="th" scope="row">{item?.shipping_to}</TableCell>
                      <TableCell component="th" scope="row">{item?.shipping_date ? dayjs(item?.shipping_date).format("DD/MM/YYYY") : "-"}</TableCell>
                      <TableCell component="th" scope="row">{item?.arrival_date ? dayjs(item?.arrival_date).format("DD/MM/YYYY") : "-"}</TableCell>
                      <TableCell component="th" scope="row">{item?.consignee}</TableCell>
                      <TableCell component="th" scope="row">{item?.no_of_invoice}</TableCell>
                      <TableCell component="th" scope="row">{item?.warehouse_location}</TableCell>
                      <TableCell component="th" scope="row" align="right">
                        <Tooltip title="Download Item List As EXCEL">
                          <Button onClick={(e) => { downloadItemCSV(item?.id); }} className="TableActionBU"><File /></Button>
                        </Tooltip>
                        <Tooltip title="Download Item List As PDF">
                          <Button onClick={(e) => { downloadItemPdf(item?.id); }} className="TableActionBU">
                            <FileText />
                          </Button>
                        </Tooltip>
                      </TableCell>
                    </StyledMainTableRow>);
                  })}

                  {filteredData.length === 0 && (<TableRow>
                    <TableCell colSpan={12} align="center">No data found</TableCell>
                  </TableRow>)}
                </TableBody>

                {filteredData.length > 0 && (<TableFooter>
                  <TableRow>
                    <TablePaginationComponent
                      count={filteredData.length}
                      colSpan={6}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      handleChangePage={paginationChangePage}
                      handleChangeRowsPerPage={
                        paginationChangeRowsPerPage
                      }
                    />
                  </TableRow>
                </TableFooter>)}
              </Table>
            </TableContainer>
          </div>
        </>)}
      </div>
    </div>
  </>);
}

export default withAdminAuth(ShippingList);